import { usePlanFeaturesQuery } from '@/hooks/queries/use-plan-features-query';
import type { PlanQuotaMeta } from '@fluenceur/types';

/**
 * The organization's profile unlocks this month, as `GET /dashboard/features`
 * states them (an unlock writes its answer back into that read). Undefined
 * while the features load; a plan that masks nothing answers a null `limit`.
 */
export function useProfileUnlockQuota(): PlanQuotaMeta | undefined {
  const { data } = usePlanFeaturesQuery();
  return data?.profileUnlocks;
}
